/**
 * @generated SignedSource<<0360dcb59a0ce1b9786bc5c17dec7cc1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_buyPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopAppliedFilters_itemSearch" | "SbRespSortItems_itemSearch" | "SharedFollowTopButton_itemSearch">;
  readonly " $fragmentType": "BuyRespTopNav_buyPage";
};
export type BuyRespTopNav_buyPage$key = {
  readonly " $data"?: BuyRespTopNav_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNav_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_buyPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "4be730189bd8b4e3e567cab68cc24599";

export default node;
